/**
 * Olive.III — Luxury Product Card Gallery Slider & Swatch Handler
 * 1. Arrow navigation to browse product images with smooth cross-fade
 * 2. On hover out (mouseleave), smoothly resets to the primary/active variant image
 * 3. Variant colour swatches switch the card image, price, compare-at price, and links
 */

(function () {
  function initLuxuryCardSliders() {
    var cardWrappers = document.querySelectorAll('.luxury-product-card-wrapper:not([data-luxury-initialized])');
    cardWrappers.forEach(function (cardWrapper) {
      cardWrapper.setAttribute('data-luxury-initialized', 'true');

      var card = cardWrapper.querySelector('.luxury-product-card') || cardWrapper;
      var slider = cardWrapper.querySelector('.luxury-card-media-slider');
      if (!slider) return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.luxury-card-slide'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('.luxury-card-dot'));
      var prevBtn = slider.querySelector('.luxury-card-arrow--prev');
      var nextBtn = slider.querySelector('.luxury-card-arrow--next');
      var total = slides.length;

      var currentIndex = 0;
      var baseIndex = 0;

      // Find initial active slide
      slides.forEach(function (slide, idx) {
        if (slide.classList.contains('active')) {
          currentIndex = idx;
          baseIndex = idx;
        }
      });

      function goToSlide(index) {
        if (total <= 0) return;

        if (index < 0) {
          currentIndex = total - 1;
        } else if (index >= total) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        slides.forEach(function (slide, i) {
          if (i === currentIndex) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });

        dots.forEach(function (dot, i) {
          if (i === currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Arrow navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex + 1);
        });
      }

      // Smooth reset on hover out (mouseleave)
      // When cursor leaves the card, smoothly transition back to baseIndex (active variant image)
      card.addEventListener('mouseleave', function () {
        if (currentIndex !== baseIndex) {
          goToSlide(baseIndex);
        }
      });

      // Mobile touch swipe support
      var touchStartX = 0;
      var touchEndX = 0;

      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        var isRtl = document.documentElement.dir === 'rtl';
        if (Math.abs(diff) > 40) {
          if ((!isRtl && diff > 0) || (isRtl && diff < 0)) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
      }, { passive: true });

      // Variant Swatch Handler (delegated on cardWrapper for total reliability)
      cardWrapper.addEventListener('click', function (e) {
        var swatchLink = e.target.closest('.variant-option-color a.swatch');
        if (!swatchLink) return;

        e.preventDefault();
        e.stopPropagation();

        var swatchSpan = swatchLink.querySelector('span') || swatchLink;

        var mediaId = swatchLink.getAttribute('data-media-id') || swatchSpan.getAttribute('data-media-id') || '';
        var filename = swatchLink.getAttribute('data-image-filename') || swatchSpan.getAttribute('data-image-filename') || '';
        var highresImg = swatchLink.getAttribute('data-highres-image') || swatchSpan.getAttribute('data-highres-image') || '';
        var dataImage = swatchSpan.getAttribute('data-image') || '';
        var variantPrice = swatchLink.getAttribute('data-variant-price') || swatchSpan.getAttribute('data-variant-price');
        var variantCompare = swatchLink.getAttribute('data-variant-compare') || swatchSpan.getAttribute('data-variant-compare');
        var variantUrl = swatchLink.getAttribute('data-variant-url') || swatchLink.getAttribute('data-href');

        // Clean filename fallback
        if (!filename && dataImage) {
          filename = dataImage.split('?')[0].split('/').pop().replace(/_\d+x\./, '.');
        }

        // 1. Try matching slide by media ID
        var matchingIndex = -1;
        if (mediaId && mediaId !== '' && mediaId !== 'null' && mediaId !== 'undefined') {
          for (var i = 0; i < slides.length; i++) {
            var sMediaId = slides[i].getAttribute('data-media-id');
            if (sMediaId && String(sMediaId) === String(mediaId)) {
              matchingIndex = i;
              break;
            }
          }
        }

        // 2. Try matching slide by filename
        if (matchingIndex === -1 && filename) {
          for (var j = 0; j < slides.length; j++) {
            var sFilename = slides[j].getAttribute('data-image-filename') || '';
            var sImg = slides[j].querySelector('img');
            var sSrc = sImg ? (sImg.getAttribute('src') || '') : '';
            var sSrcset = sImg ? (sImg.getAttribute('srcset') || '') : '';

            if (sFilename && sFilename.toLowerCase() === filename.toLowerCase()) {
              matchingIndex = j;
              break;
            }
            if (sSrc.toLowerCase().indexOf(filename.toLowerCase()) !== -1 || sSrcset.toLowerCase().indexOf(filename.toLowerCase()) !== -1) {
              matchingIndex = j;
              break;
            }
          }
        }

        // 3. Apply slide transition
        if (matchingIndex !== -1) {
          baseIndex = matchingIndex;
          goToSlide(matchingIndex);
        } else if (highresImg || dataImage) {
          // Dynamic image fallback: update active slide's image directly
          var activeSlide = slides[currentIndex] || slides[0];
          if (activeSlide) {
            var imgElem = activeSlide.querySelector('img');
            if (imgElem) {
              var targetSrc = highresImg || dataImage;
              imgElem.src = targetSrc;
              if (targetSrc.indexOf('cdn.shopify.com') !== -1) {
                var cleanUrl = targetSrc.replace(/&width=\d+/, '').replace(/\?width=\d+&?/, '?');
                var sep = cleanUrl.indexOf('?') !== -1 ? '&' : '?';
                imgElem.srcset = [360, 540, 720, 900, 1080].map(function (w) {
                  return cleanUrl + sep + 'width=' + w + ' ' + w + 'w';
                }).join(', ');
              } else {
                imgElem.removeAttribute('srcset');
              }
            }
          }
        }

        // 4. Update swatch active border ring
        var allSwatches = cardWrapper.querySelectorAll('.variant-option-color a.swatch');
        allSwatches.forEach(function (s) {
          s.classList.remove('active');
        });
        swatchLink.classList.add('active');

        // 5. Update price and compare-at price
        var currencyElem = cardWrapper.querySelector('.luxury-price-currency');
        var currencyCode = currencyElem ? currencyElem.textContent.trim() : 'AED';

        var cleanPrice = function (val) {
          if (!val) return '';
          // Strip redundant currency symbols/letters, preserving numerals, commas, and dots
          var match = String(val).match(/[\d.,]+/);
          return match ? match[0].trim() : String(val).trim();
        };

        var priceCurrent = cardWrapper.querySelector('.luxury-price-current');
        if (priceCurrent && variantPrice) {
          var cleanCurrentPrice = cleanPrice(variantPrice);
          priceCurrent.innerHTML = '<span class="luxury-price-currency">' + currencyCode + '</span><span class="luxury-price-amount">' + cleanCurrentPrice + '</span>';
        }

        var priceCompare = cardWrapper.querySelector('.luxury-price-compare');
        var priceWrap = cardWrapper.querySelector('.luxury-card-price');
        if (priceCompare && variantCompare && variantCompare.trim() !== '') {
          var cleanComparePrice = cleanPrice(variantCompare);
          priceCompare.innerHTML = '<span class="luxury-price-currency">' + currencyCode + '</span><span class="luxury-price-amount">' + cleanComparePrice + '</span>';
          priceCompare.style.display = 'inline-flex';
          if (priceWrap) priceWrap.classList.add('luxury-card-price--sale');
        }

        // 6. Update product links and quick-add button to selected variant URL
        if (variantUrl) {
          var links = cardWrapper.querySelectorAll('.luxury-card-img-link, .luxury-card-title a');
          links.forEach(function (l) {
            l.setAttribute('href', variantUrl);
          });

          var quickAddBtn = cardWrapper.querySelector('.luxury-quick-add-btn');
          if (quickAddBtn) {
            quickAddBtn.setAttribute('data-product-url', variantUrl);
          }
        }
      });
    });
  }

  // Expose globally for infinite scroll, AJAX pagination, and facet filters
  window.initLuxuryCardSliders = initLuxuryCardSliders;

  // Initialize on load and Shopify theme editor updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuxuryCardSliders);
  } else {
    initLuxuryCardSliders();
  }

  document.addEventListener('shopify:section:load', initLuxuryCardSliders);
  document.addEventListener('shopify:section:select', initLuxuryCardSliders);
  document.addEventListener('collection:page-loaded', initLuxuryCardSliders);
})();
